/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechScreenGenericIcon16Light } from './TechScreenGenericIcon16Light';
import { TechScreenGenericIcon16Regular } from './TechScreenGenericIcon16Regular';
import { TechScreenGenericIcon16Solid } from './TechScreenGenericIcon16Solid';
import { TechScreenGenericIcon20Light } from './TechScreenGenericIcon20Light';
import { TechScreenGenericIcon20Regular } from './TechScreenGenericIcon20Regular';
import { TechScreenGenericIcon20Solid } from './TechScreenGenericIcon20Solid';
import { TechScreenGenericIcon24Regular } from './TechScreenGenericIcon24Regular';
import { TechScreenGenericIcon24Solid } from './TechScreenGenericIcon24Solid';
import { TechScreenGenericIcon32Regular } from './TechScreenGenericIcon32Regular';
import { TechScreenGenericIcon64Regular } from './TechScreenGenericIcon64Regular';
var sizes = {
    16: {
        light: TechScreenGenericIcon16Light,
        regular: TechScreenGenericIcon16Regular,
        solid: TechScreenGenericIcon16Solid,
    },
    20: {
        light: TechScreenGenericIcon20Light,
        regular: TechScreenGenericIcon20Regular,
        solid: TechScreenGenericIcon20Solid,
    },
    24: {
        regular: TechScreenGenericIcon24Regular,
        solid: TechScreenGenericIcon24Solid,
    },
    32: {
        regular: TechScreenGenericIcon32Regular,
    },
    64: {
        regular: TechScreenGenericIcon64Regular,
    },
};
export var TechScreenGenericIcon = forwardRef('TechScreenGenericIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
